module.exports = __webpack_public_path__ + "img/icon_home_ht.07cf6cc7.png";